<template>
  <nav>
    <v-app-bar
      v-if="currentRoute !== 'signin'"
      flat
      app
      clipped-left 
      :color="bannerColor">
      <v-app-bar-nav-icon
        large
        class="white--text"
        @click="drawer = !drawer"
      />
      <v-spacer />
      <div class="ml-14 text-h6 white--text">Indexed At Grading</div>
      <v-spacer />

      <v-icon
        v-if="environment !== 'production'"
        large
        class="white--text"
        :class="isOnline ? 'mr-4' : ''">
        mdi-dev-to
      </v-icon>
       <v-icon
          v-show="!isOnline" 
          class="mx-4 white--text"
          large>
          mdi-cloud-off-outline
        </v-icon>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              small fab
              v-on="on"
              :color="bannerColor"
              v-show="true">
              <v-icon
                @click="toggleScreen()"
                outlined>
                {{ (isFullScreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen') }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ (isFullScreen ? 'Exit' : 'Enter') }} Full Screen</span>
        </v-tooltip>
    </v-app-bar>

    <v-navigation-drawer
      v-if="currentRoute !== 'signin'"
      v-model="drawer"
      app
      clipped>
      <v-container>
        <v-row>
          <v-col>
            <v-card
            class="ma-0 pa-0"
              width="300"
              color="transparent"
              flat>
              <div style="text-align: center;">
                <img
                  style="vertical-align: middle;"
                  src="@/assets/img/favicon-96x96.png"
                  alt="IAG Logo" />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <hr color="darkgray" style="height:2px" />
      <v-list style="padding: 0;">
        <v-list-item 
          v-for="link in links"
          :key="link.text"
          :to="link.route"
          :disabled="link.disabled"
          :exact="link.exact">

          <v-list-item-icon class="mr-4">
            <v-icon :class="link.indent ? 'ml-10': ''" :disabled="link.disabled">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav> 
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      drawer: false,
      environment: null,
      isFullScreen: false
    }
  },
  mounted() {
      window.addEventListener("fullscreenchange", this.handleScreenChange);
      window.addEventListener("webkitfullscreenchange", this.handleScreenChange, false);
  },
  created() {
    this.environment = process.env.VUE_APP_MODE;
  },
  computed: {
    ...mapState(['settings','isOnline']),
    currentRoute() {
      const routeName = this.$route.name;
      return routeName;
    },
    bannerColor() {
      return 'primary';
    },
    links() {
      let links = [
        // { icon: "mdi-home", text: 'Home', route: "/", disabled: false, exact: true },
        { icon: "mdi-wrench", text: 'Configuration', route: "", disabled: false},
        { indent: true, icon: "mdi-border-all", text: 'Cage', route: "/cage", disabled: false, exact: true },
        { indent: true, icon: "mdi-knife", text: 'Dissect', route: "/dissect", disabled: false, exact: true },
        { indent: true, icon: "mdi-variable", text: 'Fixed Param', route: "/fixedParam", disabled: false, exact: true },
        { indent: true, icon: "mdi-chart-timeline-variant", text: 'Index', route: "/index", disabled: false, exact: true },
        { indent: true, icon: "mdi-percent", text: 'Proportion', route: "/proportion", disabled: false, exact: true },
        { icon: "mdi-cog", text: 'Settings', route: "/settings", disabled: false, exact: true }
      ];

      return links;
    },
    orientation() {
      var orientation = this.settings.orientation;
      return (orientation ? orientation : 'natural');
    }
  },
  methods: {
    handleScreenChange() {
      if( (screen.availHeight || screen.height-30) <= window.innerHeight) {
        this.isFullScreen = true;
      }
      else this.isFullScreen = false;
    },
    async toggleScreen() {
      try {
        if (this.isFullScreen) {
          document.webkitExitFullscreen();
          await screen.orientation.unlock();
          this.isFullScreen = false;
        }
        else {
          const body = document.getElementsByTagName("BODY")[0];
          body.webkitRequestFullscreen();
          if (this.orientation != 'natural') await screen.orientation.lock(this.orientation);
          this.isFullScreen = true;
        }
      }
      catch (error) {
        this.$root.showNoticeError(error.message);
      }
    }
  }
}
</script>

<style scoped>
  img.nav-icon:hover {
    cursor: pointer;
  }
</style>